






































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { Farm, GrowBed } from '@/models/farm';

@Component
export default class FarmsComponent extends Vue {
    private name = '';
    private location = '';
    private details = '';
    private growBedName = '';
    private growBedWidth = 0;
    private growBedLength = 0;
    private growBeds: GrowBed[] = [];

    private farmsRef = firebase.firestore().collection('farms');

    private currentlyEditingFarmId = '';

    private allFarms: Farm[] = [];

    private headers = [
        {
            text: 'Name',
            value: 'name',
            align: 'center',
        },
        {
            text: 'Location',
            value: 'location',
            align: 'center',
        },
        {
            text: 'Notes',
            value: 'details',
            align: 'center',
        },
    ];

    private isAddVisible = false;
    private isEditVisible = false;
    private isAddingGrowbed = false;

    private created(): void {
        this.updateFarms();
    }

    private submit(): void {
        if (this.currentlyEditingFarmId !== '') {
            // editing
            const doc = this.farmsRef.doc(this.currentlyEditingFarmId);

            if (doc) {
                doc.update({
                    name: this.name,
                    location: this.location,
                    details: this.details,
                    growBeds: this.growBeds,
                }).then(() => {
                    this.isEditVisible = false;
                    this.resetForm();
                    this.updateFarms();
                })
                .catch((err) => alert('Something has gone wrong: ' + err.message));
            }
        } else {
            // adding new
            this.farmsRef.add(
                {
                    name: this.name,
                    location: this.location,
                    details: this.details,
                    growBeds: this.growBeds,
                },
            ).then(() => {
                this.updateFarms();
                this.resetForm();
                this.isAddVisible = false;
            })
            .catch((err: any) => {
                alert('Oops: ' + err.message);
            });
        }
    }

    private updateFarms(): void {
        this.allFarms = [];

        this.farmsRef.get().then((snapShot) => {
            snapShot.forEach((doc) => {
                this.allFarms.push(
                    {
                        id: doc.id,
                        name: doc.data().name,
                        location: doc.data().location,
                        ...doc.data(),
                    },
                );
            });
        });
    }

    private resetForm(): void {
        this.currentlyEditingFarmId = '';
        this.name = '';
        this.location = '';
        this.details = '';
        this.growBedLength = 0;
        this.growBedWidth = 0;
        this.growBeds = [];
    }

    private toggleEdit(item: Farm): void {
        this.resetForm();
        if (item) {
            this.name = item.name;
            this.location = item.location;
            this.details = item.details ? item.details : '';
            this.currentlyEditingFarmId = item.id!!;
            this.growBeds = item.growBeds ? item.growBeds : [];
        }
        this.isEditVisible = !this.isEditVisible;
        this.isAddVisible = false;
    }

    private toggleAdd(): void {
        this.resetForm();
        this.isAddVisible = true;
    }

    private closeForm(): void {
        this.resetForm();
        this.isAddVisible = false;
        this.isEditVisible = false;
    }

    private toggleAddGrowbed(): void {
        this.isAddingGrowbed = !this.isAddingGrowbed;
    }

    private appendBed(): void {
        this.growBeds.push({
            name: this.growBedName,
            length: this.growBedLength,
            width: this.growBedWidth,
        });

        this.growBedName = '';
        this.growBedLength = 0;
        this.growBedWidth = 0;
        this.isAddingGrowbed = false;
    }

    private deleteFarm(item: any): void {
        const doc = this.farmsRef.doc(item.id);

        if (doc) {
            doc.delete().then(() => {
                this.updateFarms();
            }).catch((err) => alert('Cannot delete farm: ' + err));
        }
    }

    private onDeleteBed(index: number): void {
        this.growBeds.splice(index, 1);
    }
}
